import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { environment } from '../environment';
import { Http, Response, Headers } from '@angular/http';
import { DevTracker } from '../models/devtracker';

@Component({
  selector: 'dev-tracker',
  templateUrl: './tracker.component.html'
})

export class TrackerComponent implements OnInit {
	
  	constructor(private http   : Http,
  				private sanitizer : DomSanitizer) { }

	title: any;
	header: any;
	subtitle: any;
  	tweets: any;
  	headerHeight: any;
  	headerAlign: any;
	devPosts: DevTracker;

	getDevTracker(): Promise<DevTracker> {
		return this.http
		.get(`${environment.baseUrl}/devtracker/`,
		{headers: this.getHeaders()})
			.toPromise()
			.then(mapDevPosts)
			.catch((err) => {
				console.log(err);
		})
	}

	private getHeaders() {
		let headers = new Headers();
		headers.append('Accept', 'application/json');
		return headers;
	}


	/* On with the show */
	ngOnInit() {

		Promise.resolve(this.getDevTracker()).then(posts =>
			this.devPosts = posts
		);

		// Twitter
		!function(d,s,id){
            var js: any,
                fjs=d.getElementsByTagName(s)[0],
                p='https';
            if(!d.getElementById(id)){
                js=d.createElement(s);
                js.id=id;
                js.src=p+"://platform.twitter.com/widgets.js";
                fjs.parentNode.insertBefore(js,fjs);
            }
        }
        (document,"script","twitter-wjs");

        this.title = 'UPDATES';
	    this.headerHeight = '498px';
	    this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/header-faq.jpg")' );
	    this.subtitle = 'The latest news surrounding Identity\'s development';

	}

}


/**
* 		Managing dev posts
**/

function mapDevPosts(response?:Response): DevTracker {
	let res = response.json().map(toDevPost);
	return res;
}

function toDevPost(r?:any): DevTracker {
	let devTrackers = <DevTracker>({
		pid: r.pid,
		topic_id: r.topic_id,
		title: r.title,
		title_seo: r.title_seo,
		post: r.post,
		post_date: r.post_date,
		author: r.author
	});
	return devTrackers;
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/tracker/tracker.component.ts